export var arrayToObject = function arrayToObject(array) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
  return array.reduce(function (obj, item) {
    obj[item[key]] = item;
    return obj;
  }, {});
};
/**
 * Returns array of ids in the same order as the input array
 * of objects
 */

export var arrayOfObjectsOrder = function arrayOfObjectsOrder(array) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id'; // TODO: Check return type.

  var order = [];

  for (var i = 0; i < array.length; i++) {
    order.push(array[i][key]);
  }

  return order;
};
export var normaliseArrayOfObjects = function normaliseArrayOfObjects(array) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
  return {
    byId: arrayToObject(array, key),
    order: arrayOfObjectsOrder(array, key)
  };
};